const dashboard = {
  title: 'Panel de Control',
  welcome: 'Bienvenido de nuevo',
  no_data: 'No se encontraron resultados',
  no_data_description: 'No hay datos disponibles en este momento',
};

export default dashboard;
